import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class DataUserService {

  constructor(private http: HttpClient,
    private config: ConfigService) { }

  getEmpresaVinculada(token: String) {
    const requestOptions =  new Object ({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url: string = this.config.urlService + "api/DataUser/Proveedor";
    return this.http.get(url, requestOptions);
  }


  getDataUser(token:String){
    const requestOptions =  new Object ({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url: string = this.config.urlService + "api/DataUser/User/";
    return this.http.get(url, requestOptions);
  }

  getMenuProfile(token:String){
    const requestOptions =  new Object ({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url: string = this.config.urlService + "api/DataUser/Menu";
    return this.http.get(url, requestOptions);

    
  }
}
